module.exports = __webpack_public_path__ + "static/QualityBanner-1b6c3b865fc579f1ce2c7650a270ce60.jpg";